import React, { useState, useEffect } from 'react';
import { documentApi } from '../api';

interface HelloSignPreviewProps {
  signatureRequestId: string;
  height?: string;
  width?: string;
}

const HelloSignPreview: React.FC<HelloSignPreviewProps> = ({
  signatureRequestId,
  height = '800px',
  width = '100%'
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  // Get the preview URL
  const previewUrl = documentApi.getHellosignPreviewUrl(signatureRequestId);
  
  useEffect(() => {
    // Reset states when signature request ID changes
    setLoading(true);
    setError(null);
  }, [signatureRequestId]);
  
  const handleLoad = () => {
    setLoading(false);
  };
  
  const handleError = () => {
    setLoading(false);
    setError('Failed to load the document. Please try again later.');
  };

  return (
    <div className="pdf-preview-container">
      {loading && (
        <div className="flex justify-center items-center p-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      )}
      
      {error && (
        <div className="text-red-500 p-4 border border-red-300 rounded bg-red-50">
          {error}
        </div>
      )}
      
      <iframe
        src={previewUrl}
        width={width}
        height={height}
        style={{ border: 'none' }}
        onLoad={handleLoad}
        onError={handleError}
        title="Document Preview"
      />
    </div>
  );
};

export default HelloSignPreview; 